import React from 'react';
import {
  DatePicker as MuiDatePicker,
  DateTimePicker as MuiDateTimePicker,
  TimePicker as MuiTimePicker,
} from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';

const LegacyTextField = React.forwardRef(function LegacyTextField(
  { legacyDisplayValue, inputProps, ...textFieldProps },
  ref,
) {
  return (
    <TextField
      {...textFieldProps}
      ref={ref}
      inputProps={{
        ...inputProps,
        ...(legacyDisplayValue !== undefined ? { value: legacyDisplayValue } : {}),
      }}
    />
  );
});

const createLegacyPicker = (Picker, defaultInputFormat) => {
  const LegacyPicker = ({
    inputVariant = 'outlined',
    labelFunc,
    autoOk,
    slots,
    slotProps,
    ...props
  }) => {
    const [internalOpen, setInternalOpen] = React.useState(false);
    const displayValue = labelFunc ? labelFunc(props.value) : undefined;

    const handleOpen = () => {
      if (props.open === undefined) {
        setInternalOpen(true);
      }
      props.onOpen?.();
    };

    const handleClose = () => {
      if (props.open === undefined) {
        setInternalOpen(false);
      }
      props.onClose?.();
    };

    const getTextFieldSlotProps = (ownerState) => {
      const externalTextFieldProps =
        typeof slotProps?.textField === 'function'
          ? slotProps.textField(ownerState)
          : slotProps?.textField;

      return {
        ...externalTextFieldProps,
        variant: inputVariant,
        legacyDisplayValue: displayValue,
        onClick: (event) => {
          externalTextFieldProps?.onClick?.(event);

          const clickedPickerButton = event.target.closest('button');
          if (
            !event.defaultPrevented &&
            !clickedPickerButton &&
            !props.disabled &&
            !props.readOnly
          ) {
            handleOpen();
          }
        },
      };
    };

    const textFieldSlotProps =
      typeof slotProps?.textField === 'function'
        ? getTextFieldSlotProps
        : getTextFieldSlotProps();

    return (
      <Picker
        {...props}
        open={props.open ?? internalOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        format={props.format || defaultInputFormat}
        closeOnSelect={autoOk || props.closeOnSelect}
        slots={{ ...slots, ...(labelFunc ? { textField: LegacyTextField } : {}) }}
        slotProps={{ ...slotProps, textField: textFieldSlotProps }}
      />
    );
  };

  return LegacyPicker;
};

export const DatePicker = createLegacyPicker(MuiDatePicker, 'jYYYY/jMM/jDD');
export const DateTimePicker = createLegacyPicker(MuiDateTimePicker, 'jYYYY/jMM/jDD HH:mm:ss');
export const TimePicker = createLegacyPicker(MuiTimePicker, 'HH:mm');
